import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CitiesTable from "../../components/citiesTable";
import { getCitiesList } from "./actions";
import CustomModal from "../../components/customModal";

const Cities = () => {
  const { pageNo, limit, searchKey, sortOrder, sortBy } = useSelector(
    (state) => state.CityReducer
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCitiesList());
  }, [pageNo, limit, searchKey, sortOrder, sortBy]);

  return (
    <div>
      <CitiesTable />
    </div>
  );
};

export default Cities;
